import { HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import { MarketInputText, MarketButton } from '@market/react';
import styles from 'typescript/components/postal_code_search_input.module.scss';

interface PostalCodeSearchInputProps extends HTMLAttributes<HTMLDivElement> {
  value: string;
  onValueChange: (value: string) => void;
  onButtonClick?: () => void;
  maxLength?: number;
  showSearchButton?: boolean;
  inputTestId?: string;
  buttonTestId?: string;
}

const PostalCodeSearchInput = ({
  value,
  onValueChange,
  onButtonClick,
  maxLength = 10,
  showSearchButton = false,
  className,
  inputTestId,
  buttonTestId,
}: PostalCodeSearchInputProps) => {
  const { t } = useTranslation();

  const handleInputChange = (event) => {
    const newValue = event?.detail?.value;
    onValueChange(newValue);
  };

  return (
    <div
      className={`${styles.container} ${className} ${showSearchButton ? styles.containerWithButton : null}`}
    >
      <MarketInputText
        data-testid={inputTestId}
        className={`${styles.inputField} ${className}`}
        maxlength={maxLength}
        onMarketInputValueChange={handleInputChange}
        slot="trigger"
        value={value}
        placeholder={t('checkout.delivery.pickup.zipCode')}
      >
        <label>{t('checkout.delivery.pickup.zipCode')}</label>
      </MarketInputText>

      {showSearchButton && (
        <MarketButton
          data-testid={buttonTestId}
          type="button"
          rank="primary"
          size="medium"
          className={styles.searchButton}
          onClick={onButtonClick}
        >
          {t('common.search')}
        </MarketButton>
      )}
    </div>
  );
};

export default PostalCodeSearchInput;
